var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineChartUp02 = function SvgLineChartUp02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.058 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V2h1.5v17.692q0 .116.096.212a.3.3 0 0 0 .212.096H21.75v1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.501 16.006-1.03-1.03 6.006-5.912 3.51 3.609 4.26-4.4h-1.913V6.8h4.416v4.415h-1.472V9.303l-5.291 5.467-3.51-3.608z"
  })));
};
export default SvgLineChartUp02;